import type { TodaySummaryMetrics } from "@ceo-cmd/shared";
import { cn } from "@/cn";
import { formatMoney } from "./labels";

type MetricDef = {
  key: keyof TodaySummaryMetrics;
  label: string;
  filterHint: string;
  money?: boolean;
};

/** Three mutually exclusive counts + one exposure aggregate. */
const METRICS: MetricDef[] = [
  {
    key: "actionsRequiringCeo",
    label: "Act now",
    filterHint: "act_now",
  },
  {
    key: "decisionsRequired",
    label: "Decisions / approvals",
    filterHint: "decision_required",
  },
  { key: "atRisk", label: "At risk", filterHint: "at_risk" },
  {
    key: "portfolioExposure",
    label: "Portfolio exposure",
    filterHint: "all_active",
    money: true,
  },
];

export function ExecutiveSummaryStrip({
  metrics,
  activeFilter,
  onSelect,
}: {
  metrics: TodaySummaryMetrics;
  activeFilter?: string;
  onSelect: (hint: string) => void;
}) {
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
      {METRICS.map((m) => {
        const raw = metrics[m.key];
        const value =
          m.money && typeof raw === "number"
            ? formatMoney(raw, metrics.currency)
            : String(raw);
        const selected = activeFilter === m.filterHint;
        return (
          <button
            key={m.key}
            type="button"
            onClick={() => onSelect(m.filterHint)}
            className={cn(
              "rounded-md border px-3 py-2.5 text-left transition",
              selected
                ? "border-brand/50 bg-brand-soft/60"
                : "border-border/80 bg-card/80 hover:bg-surface-hover",
            )}
          >
            <p className="text-[10px] font-medium uppercase tracking-wide text-muted-foreground">
              {m.label}
            </p>
            <p className="mt-0.5 text-lg font-semibold tabular-nums text-foreground">
              {value}
            </p>
          </button>
        );
      })}
    </div>
  );
}
